import type { UnwrapRef } from 'vue';

import type { MfaFormValues} from './MfaTypes';
import { MfaInputIdEnum } from './MfaTypes';


export const onPaste = (evt: ClipboardEvent, formValues: UnwrapRef<Partial<MfaFormValues>>) => {
  evt.preventDefault();

  // parse first 6 digits of paste value
  const pasteText = evt.clipboardData?.getData('text');
  if (!pasteText) {
    throw Error('Could not paste');
  }
  const code = pasteText.slice(0, 6);

  // Chop up the pasted text and add the values to the inputs
  const input1 = document.getElementById(MfaInputIdEnum.digit1) as HTMLInputElement;
  const input2 = document.getElementById(MfaInputIdEnum.digit2) as HTMLInputElement;
  const input3 = document.getElementById(MfaInputIdEnum.digit3) as HTMLInputElement;
  const input4 = document.getElementById(MfaInputIdEnum.digit4) as HTMLInputElement;
  const input5 = document.getElementById(MfaInputIdEnum.digit5) as HTMLInputElement;
  const input6 = document.getElementById(MfaInputIdEnum.digit6) as HTMLInputElement;

  input1.value = code.slice(0, 1);
  input2.value = code.slice(1, 2);
  input3.value = code.slice(2, 3);
  input4.value = code.slice(3, 4);
  input5.value = code.slice(4, 5);
  input6.value = code.slice(5, 6);

  formValues.digit1 = Number(code.slice(0, 1));
  formValues.digit2 = Number(code.slice(1, 2));
  formValues.digit3 = Number(code.slice(2, 3));
  formValues.digit4 = Number(code.slice(3, 4));
  formValues.digit5 = Number(code.slice(4, 5));
  formValues.digit6 = Number(code.slice(5, 6));

  // submit form
  const submitButton = document.querySelector('.mfa-form button[type=submit]') as HTMLButtonElement;
  submitButton.disabled = false; // annoying
  const click = new MouseEvent('click');
  if (submitButton) {
    submitButton.dispatchEvent(click);
  } else {
    throw Error('no button found.');
  }
};

export const onKeyUp = (event: KeyboardEvent) => {
  // skip this event on paste, i.e. Cmd+V
  if (['Control', 'Meta', 'V', 'v'].includes(event.key)) {
    return;
  }

  const {
    digit1, digit2, digit3, digit4, digit5, digit6,
  } = MfaInputIdEnum;

  const digit1Element = document.getElementById(digit1) as HTMLInputElement;
  const digit2Element = document.getElementById(digit2) as HTMLInputElement;
  const digit3Element = document.getElementById(digit3) as HTMLInputElement;
  const digit4Element = document.getElementById(digit4) as HTMLInputElement;
  const digit5Element = document.getElementById(digit5) as HTMLInputElement;
  const digit6Element = document.getElementById(digit6) as HTMLInputElement;

  // backspace functionality: hitting backspace should move cursor back one input field
  const currentTarget = event.currentTarget as HTMLInputElement;
  if (event.key === 'Backspace') {
    switch (currentTarget.id) {
      case digit2:
      // const digit1Element = document.getElementById(digit1) as HTMLInputElement;
        window.setTimeout(() => digit1Element?.focus(), 1);
        return;
      case digit3:
        window.setTimeout(() => digit2Element?.focus(), 1);
        return;
      case digit4:
        window.setTimeout(() => digit3Element?.focus(), 1);
        return;
      case digit5:
        window.setTimeout(() => digit4Element?.focus(), 1);
        return;
      case digit6:
        window.setTimeout(() => digit5Element?.focus(), 1);
        return;
    }
  }

  /**
   * cursor/focus functionality: typing a number should automatically move the cursor to next input
   */
  const click = new MouseEvent('click');
  const submitButton = document.querySelector('.mfa-form button[type=submit]');

  if (!submitButton) {
    throw Error('no button found.');
  }

  if (
    currentTarget.value.length >= currentTarget?.maxLength
      && event.key !== 'Shift'
      && event.key !== 'Tab'
      && event.key !== 'Backspace'
  ) {

    switch (currentTarget.id) {
      case digit1:
        digit2Element.focus();
        break;
      case digit2:
        digit3Element.focus();
        break;
      case digit3:
        digit4Element.focus();
        break;
      case digit4:
        digit5Element.focus();
        break;
      case digit5:
        digit6Element.focus();
        break;
      case digit6:
      // submit form
        submitButton.dispatchEvent(click);
        break;
    }
  }
};

